/**
 * 学习乐园 · 排排序题材包：生肖顺序（paixu/pack-shengxiao.js）
 * ---------------------------------------------------------------------------
 * 十二生肖按次序排（鼠牛虎兔龙蛇马羊猴鸡狗猪）。note 讲这只生肖与
 * 地支时辰的对应——生肖次序不是硬背出来的，它本来就是一天十二时辰
 * 从子时到亥时挨个排下来的；排一遍顺带把「子鼠丑牛寅虎……」的来历过一遍。
 * 与连连看「生肖配地支」题材同一条知识线，那边配对、这边排序。
 */
(function (global) {
  'use strict';
  var PACKS = global.STPX_PACKS = global.STPX_PACKS || {};

  PACKS.shengxiao = {
    id: 'shengxiao',
    name: '生肖顺序',
    hint: '十二生肖从头排到尾',
    cols: 6,
    winText: '鼠牛虎兔龙蛇马羊猴鸡狗猪——这个次序正好对上子丑寅卯十二时辰。',
    items: [
      { face: '鼠', note: '生肖之首，夜里十一点到一点（子时）最活跃' },
      { face: '牛', note: '耕地拉车的好帮手，丑时还在慢慢反刍' },
      { face: '虎', note: '山林之王，寅时最威风' },
      { face: '兔', note: '卯时天刚亮，出窝吃带露水的草' },
      { face: '龙', note: '十二生肖里唯一想象出来的，管行云布雨' },
      { face: '蛇', note: '又叫小龙，巳时暖和了才出洞' },
      { face: '马', note: '午时日头最盛，正是它撒开四蹄的时候' },
      { face: '羊', note: '未时吃草，长得最壮' },
      { face: '猴', note: '申时最爱啼叫嬉闹' },
      { face: '鸡', note: '酉时天黑前归窝' },
      { face: '狗', note: '戌时守门最尽职' },
      { face: '猪', note: '亥时睡得最沉，给十二生肖收尾' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
